import '../LibraryBoxBattle.scss'
import NP from "../../../1. Core/NP";
import Control from "../../../1. Core/Control";
import ListGroupHeader from "../../../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../../../1. Core/Delegate";
import IconSelect from "../../../1. Core/Controls/Select/IconSelect";
import {getWeights, getWeightString, Weight} from "../../Util";
import {SportType} from "../../types";
import {IStateFiltersSort} from "../../../2. Athletes/StatesList";

export default class StatesFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	//private _tournamentCombo: IconSelect;
	private _regionsCombo: IconSelect;
	private _genderCombo: IconSelect;
	private _weightCombo: IconSelect;
	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	private _sortLabel: ListGroupHeader;

	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._regionsCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Regions'),
			SelectedIndex: 0,

			Items: [{
				Value: null,
				FontImage: NP.FontImages.geo,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});


		this._genderCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 'All',
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('All')
			},{
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleGender')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleGender')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._weightCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('WeightCategory'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.weight,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortLabel = new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: 'SumRaiting',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortBySumRating')
			}, {
				Value: 'Efficiency',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByEfficiency')
			}, {
				Value: 'Rating',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByRating')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this._loadFilters();
	}

	setSortVisible(value: boolean)
	{
		NP.setIsVisible([this._sortLabel, this._sortDirectionCombo, this._sortFieldCombo], value)
	}

	_loadFilters()
	{
		getWeights({Type: SportType.Box}).then((res: Weight[]) =>
		{
			let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));
			this._weightCombo.addItems(items);
		});
		// getRegions().then((res: IState[]) =>
		// {
		// 	let items = res.map(region => ({Value: region.Id, FontImage: NP.FontImages.geo, Content: region.Name}));
		// 	if (this._regionsCombo)
		// 		this._regionsCombo.addItems(items);
		// });
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData() : IStateFiltersSort
	{
		let regName = this._regionsCombo.getSelectedItem() && this._regionsCombo.getSelectedItem().Content;
		if (regName == NP.RM.getString('All'))
			regName = null;

		return {
			RegionName: regName,
			Sex: this._genderCombo.getValue() == 'All' ? null : this._genderCombo.getValue(),
			RegionId: this._regionsCombo.getValue(),
			WeightCategory: this._weightCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue()
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
};